import { apiRoutes } from "../../../routing/routes";

export type DocumentDeliveryInfo = {
  status: "ACTIVE" | "INACTIVE";
  email?: string;
  memberId?: number;
};

export async function saveDocumentDeliveryInfo(
  info: DocumentDeliveryInfo
): Promise<void> {
  const response = await fetch(apiRoutes.paperless, {
    headers: {
      "content-type": "application/json",
    },
    method: "PUT",
    body: JSON.stringify({
      status: info.status,
      email: info.email,
      memberId: info.memberId,
    }),
  });

  if (!response.ok) {
    throw response;
  }
}
